import type { JSX } from "react";
import type { DeleteOperation } from "./delete-operation";
import { Stack } from "@mui/material";
import { ConfirmDeletionCheckbox } from "../components/molecules/confirm-deletion-checkbox";
import { PermanentlyDeleteAlert } from "../components/molecules/permanently-delete-alert";


export type DeleteOperationViewProps = {
	operation: DeleteOperation;
};
export const DeleteOperationView = ({ operation }: DeleteOperationViewProps): JSX.Element => {
	return (
		<>
			<PermanentlyDeleteAlert verb={ operation.verb } resourceName={ operation.resourceName } square/>
			<Stack className="pad">
				{ operation.message }
				<ConfirmDeletionCheckbox verb={ operation.verb } resourceName={ operation.resourceName }/>
			</Stack>
		</>
	);
};
